<div class="cm-filters-container">
    <ng-content></ng-content>
</div>
